import { StoreThunk } from './types';

declare global {
  interface Window {
    snowplow: Snowplow;
  }
}

interface Snowplow {
  (
    trackingType: string,
    category?: string,
    action?: string,
    label?: string | null,
    property?: string | null,
    value?: number | null
  ): StoreThunk<void>;
}

export interface SnowplowOpts {
  eventCategory: string;
  eventAction: string;
  eventContext: string | null;
  eventId: number | null;
}

interface ScriptOpts {
  API_HOST: string;
  DASHBOARD_DOMAIN: string;
}

export function trackSnowplowEvent(opts: SnowplowOpts): StoreThunk<void> {
  const category = opts.eventCategory;
  const action = opts.eventAction;
  const label = opts.eventContext;
  const property = null;
  const value = opts.eventId;

  if (window.snowplow) {
    window.snowplow('trackPageView');
    window.snowplow('setUserId', 'unknown');
    window.snowplow(
      'trackStructEvent',
      category,
      action,
      label,
      property,
      value
    );
  }

  return () => {
    // nothing to return
  };
}

export function injectSnowplow() {
  const API_HOST = process.env.REACT_APP_API_HOST || null;
  const DASHBOARD_DOMAIN = process.env.REACT_APP_DASHBOARD_DOMAIN || null;

  if (API_HOST && DASHBOARD_DOMAIN) {
    const script = document.createElement('script');
    const snowplowScript = getSnowplowScript({ API_HOST, DASHBOARD_DOMAIN });
    const snowplowNode = document.createTextNode(snowplowScript);
    script.type = 'text/javascript';
    script.async = true;
    script.appendChild(snowplowNode);
    document.head.appendChild(script);
  }
}

function getSnowplowScript({ API_HOST, DASHBOARD_DOMAIN }: ScriptOpts): string {
  return `;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
    p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
    };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
    n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script",
    "${process.env.PUBLIC_URL}/snowplow/snowplow.js","snowplow"));

    // Configure script.
    snowplow('newTracker', 'ssc', '${API_HOST}/snowplow', {
      appId: "snowplowPOC",
      cookieDomain: "${DASHBOARD_DOMAIN}",
      post: true,
      bufferSize: 1,
      forceSecureTracker: true,
      stateStorageStrategy: "cookie",
      contexts: {
        webPage: true,
        performanceTiming: true,
        gaCookies: true,
        geolocation: false
      }
    });`;
}



// WEBPACK FOOTER //
// ./src/actions/snowplow.ts